<div class="min-h-screen flex items-center justify-center">
  <div class="w-full max-w-sm">
    <div class="bg-white shadow-lg rounded-2xl p-6">
      <!-- Logo -->
      <div class="flex justify-center mb-6">
        <div class="w-24 h-24 rounded-full flex items-center justify-center p-2 bg-[#333131]">
          <img
            src="./assets/images/publio_logo_trans_bg.png"
            alt="Publio Logo"
            class="object-contain w-full h-full"
          />
        </div>
      </div>

      <h2 class="text-2xl font-semibold text-gray-900 text-center mb-6">Login</h2>

      <form (ngSubmit)="onSubmit()" #loginForm="ngForm" class="my-4" novalidate>
        <div class="mb-4">
          <label for="Email" class="block text-sm font-medium text-gray-700">Email</label>
          <input
            type="email"
            id="Email"
            name="Email"
            [(ngModel)]="email"
            required
            placeholder="you@example.com"
            class="mt-1 block w-full rounded-lg border-gray-300 focus:border-indigo-500
                   focus:ring-indigo-500 px-3 py-2 shadow-sm"
          />
        </div>

        <div class="mb-4">
          <label for="Password" class="block text-sm font-medium text-gray-700">Password</label>
          <input
            type="password"
            id="Password"
            name="Password"
            [(ngModel)]="password"
            required
            placeholder="••••••••"
            class="mt-1 block w-full rounded-lg border-gray-300 focus:border-indigo-500
                   focus:ring-indigo-500 px-3 py-2 shadow-sm"
          />
        </div>

        <button
          type="submit"
          [disabled]="loginForm.invalid || loading"
          class="w-full inline-flex items-center justify-center rounded-lg bg-[#007BFF]
                 px-4 py-2.5 text-white text-sm font-medium hover:bg-[#0056b3]
                 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2
                 transition disabled:opacity-60 disabled:cursor-not-allowed cursor-pointer mt-4"
        >
          <span *ngIf="!loading">Login</span>
          <span *ngIf="loading">Logging in...</span>
        </button>
      </form>

      <p
        *ngIf="message"
        [ngClass]="{
          'text-green-700': success,
          'text-red-700': !success
        }"
        class="mt-4 text-center text-sm"
      >
        {{ message }}
      </p>
    </div>

    <p class="text-center text-xs text-gray-600 mt-5">
      Copyright © {{ currentYear }}
      <span class="font-medium">Publio.ai</span> | Powered by
      <span class="font-medium">Brainfood SA</span>
    </p>
  </div>
</div>
